import { useState, useEffect } from 'react';

import Toolbar from '@lcsc-ui/components/ToolBar';
import BaseLayout from '@lcsc-ui/layouts/baseLayout';
import useUserStore from '@lcsc-ui/store/user';
import { baseURL } from '@lcsc-ui/utils/baseUrl';
import ecpCurl from '@lcsc-ui/utils/ecpCurl';
import { Breadcrumb } from 'antd';
import Head from 'next/head';
import { NextSeo } from 'next-seo';

import { addReadCount } from '@/apis/news';
import OpApi from '@/apis/op';
import StaticdataApi from '@/apis/staticdata';
import NewsDetail from '@/features/news/detail';

const Index = ({ newsDetail, resourceData, websiteSectionList, catalogList, headerAd }) => {
  const metadata = {
    title: `${newsDetail.title || '立创商城'}`,
    description: `${newsDetail.intro || '立创商城'}`,
    additionalMetaTags: [
      {
        name: 'keywords',
        content: '立创商城,元器件,电子元器件,电子元器件商城,电子元器件采购网,嘉立创',
      },
    ],
  };

  const [logined, setLogined] = useState(false);
  const { updateUserInfo } = useUserStore();
  const [isOldCus, setIsOldCus] = useState(false); // 是否为老用户
  useEffect(() => {
    autoRefreshLoginInfo();
    setIsOldCus(resourceData?.commonConfigVO?.existSendOrder || false);
    fnAddReadCount();
  }, []);
  const autoRefreshLoginInfo = (data) => {
    updateUserInfo(data);
    setLogined(true);
    window.isLogin = true;
  };
  // 添加阅读量
  function fnAddReadCount() {
    if (newsDetail?.informationId) {
      addReadCount({
        informationId: newsDetail?.informationId,
      });
    }
  }
  return (
    <>
      <NextSeo {...metadata}></NextSeo>
      <Head>
        <link
          rel="canonical"
          href={resourceData?.projectConfigVO.lcscWwwUrl + `/news/${newsDetail?.informationId}.html`}
        />
      </Head>
      <BaseLayout
        resourceData={resourceData}
        websiteSectionList={websiteSectionList}
        catalogList={catalogList}
        headerAd={headerAd}
        isLgScreen={false}
        notIndexHeaderAdapter
        onlySScreen
        logined={logined}
        isNeedTopAd={true}
        isShowBottomAd={true}
      >
        <div className="w-full h-full bg-[#F6F8FA]">
          <section className="w-[1200px] mx-auto py-[16px]">
            <div className="flex w-full justify-between items-center">
              <Breadcrumb separator=">">
                <Breadcrumb.Item className="hover:!text-[#0093e6]" href={baseURL}>
                  首页
                </Breadcrumb.Item>
                <Breadcrumb.Item className="hover:!text-[#0093e6]" href={`/news/list.html`}>
                  商城公告
                </Breadcrumb.Item>
                <Breadcrumb.Item className="text-[#0093e6]">
                  {newsDetail ? newsDetail?.title : '立创商城'}
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
            <section className="flex mt-[6px]">
              <NewsDetail newsDetail={newsDetail} />
            </section>
          </section>
        </div>
        <Toolbar isOldCus={isOldCus}></Toolbar>
      </BaseLayout>
    </>
  );
};

export async function getServerSideProps(context) {
  const { req, params } = context;
  const detailId = params.id.replace('.html', '');
  const [resourceData, catalogList, websiteSectionList, headerAd, newsDetail] = await Promise.all([
    ecpCurl(StaticdataApi.resourceList, { headers: req.headers }),
    ecpCurl(StaticdataApi.catalogList, { headers: req.headers }),
    ecpCurl(OpApi.websiteSection, { headers: req.headers }),
    ecpCurl(OpApi.advertisingHeader),
    ecpCurl(`${OpApi.opServe}/news/${detailId}`, {
      query: {
        stCatch: 'yes',
      },
    }),
  ]);
  return {
    props: {
      newsDetail: !newsDetail ? '' : newsDetail.information,
      resourceData,
      websiteSectionList,
      catalogList,
      headerAd,
    },
  };
}
export default Index;
